import React, { Component } from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import { Button, Modal, Media, ModalFooter } from 'reactstrap';

const styles = {
  headerModal: {
    fontFamily: 'Lato, Arial',
    fontSize: '14px !important',
    color: '#1F1F1F',
    fontWeight: 'bold',
    padding: '1rem 1rem 0.5rem 1rem',
    display: 'flex',
    alignItem: 'flex',
    justifyContent: 'space-between',
  },
  bodyModal: {
    fontFamily: 'Lato, Arial',
    fontSize: '14px',
    color: '#656565',
    lineHeight: '21px',
    padding: '0 1rem 1rem 1rem',
  },
  footerModal: {
    border: 'none',
  },
  actionBtn: {
    fontFamily: 'Lato, Arial',
    fontSize: '14px',
    color: '#979797',
    cursor: 'pointer',
    marginRight: '1.25rem !important',
  },
  danger: {
    color: '#ec2235',
  },
  participantInfoWrapper: {
    display: 'flex',
    border: '1px solid #E5E7E6',
    borderRadius: '1.5rem',
    padding: '3px',
    margin: '0 1rem 0.5rem 1rem',
  },
  participantName: {
    marginLeft: '0.5rem',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    lineHeight: '1.875rem',
  },
  imageWrapper: {
    width: '2rem',
    height: '2rem',
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    fontSize: '1.25rem',
    flexShrink: 0,
    fontFamily: 'Lato',
    alignItems: 'center',
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    objectFit: 'cover',
  },
};

class RemoveUserConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  render() {
    const { classes, participant, modal, handleCancelBtn, handleActionBtn, handleToggle } = this.props;
    return (
      <div>
        <Modal isOpen={modal} toggle={handleToggle} className={this.props.className}>
          <div toggle={handleToggle} className={classes.headerModal}>Remove From Previous Session</div>
          <div className={classes.participantInfoWrapper}>
            <div className={classes.imageWrapper}>
              <Media
                src={participant.image}
                className={classes.image}
                alt="Generic placeholder image"
              />
            </div>
            <div className={classes.participantName}>
              {participant.displayName}
            </div>
          </div>
          <div className={classes.bodyModal}>
            <span>Cautious! This participant will be removed from the previous session, this also means that
            this participant’s involvement will not be credited for the previous session.</span>
            <span className={classes.danger}>You cannot undo this action!</span>
          </div>
          <ModalFooter className={classes.footerModal}>
            <div className={classes.actionBtn} onClick={handleActionBtn}>Remove From Previous Session</div>{' '}
            <Button color="danger" onClick={handleCancelBtn}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

RemoveUserConfirmation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(RemoveUserConfirmation);



// WEBPACK FOOTER //
// ./src/components/RemoveUserConfirmation.js